import { EApiStatus } from './api'

// TODO: kh dung cai cua no nay nua, dung ApiResponse api.ts
export type TData<T> = {
  success: boolean
  code: number
  message: string
  data: T
}

export type TDataAuth<T> = {
  state: boolean
  status: number
  message: string
  data: T
}

export type TUser = {
  token: string
  device_token: string
  email: string
  phone: string
  address: string
  fullname: string
  club_level: number
  user_id: string
  birthday_string: string
  is_login: boolean
}

export type AuthResponse = {
  is_login: boolean
  isset_phone: boolean
  user: TUser
  user_id?: string
  fullname?: string
  email?: string
  token?: string
  device_token?: string
  phone?: string
}

export type LoginDto = {
  username: string
  password: string
  device_token?: string
}

export type RegisterDto = {
  fullname: string
  email: string
  phone: string
  password: string
  ajax?: boolean
}

export type ForgotPasswordDto = {
  email: string
}

export type Address = {
  _id: string
  default: boolean
  city?: string | null
  district?: string | null
  ward?: string | null
  address: string
  phone: string
  fullname: string
  user_id: string
  updated_at: string
  created_at: string
}

type RankingHistory = {
  ranking_id_old: string
  ranking_id_new: string
  content: string
  created_at: { $date: { $numberLong: string } }
}

type Ranking = {
  _id: string
  title: string
  slug: string
  coolcash: number
  active: number
}

export enum ERankingType {
  NEW = 'new',
  SILVER = 'silver',
  GOLD = 'gold',
  PLATINUM = 'platinum',
}

export enum ERankingSlug {
  NEW_USER = 'thanh-vien-moi',
  SILVER = 'hang-bac',
  GOLD = 'hang-vang',
  PLATINUM = 'hang-bang',
  CHAMPION = 'hang-bach-kim',
}

export type RankingConfig = {
  slug: ERankingSlug
  value: number
  max_value: number
  image: string
  mb_image: string
  next_ranking_image?: string
  rank_image: string
  user_image: string
  coefficient: number
  coefficient_line: number
  coupon_description: string
}

export type UserRanking = {
  _id: string
  user_id: string
  total_point: number
  total_value: number
  total_money: number
  total_point_pending: number
  ranking_id: ERankingLevel
  register_date: { $date: { $numberLong: string } }
  updated_at: string
  created_at: string
  total_accumulate_past: number
  history: RankingHistory[]
  ranking: Ranking
}

export type UserRankingFormatted = UserRanking &
  RankingConfig & {
    percent: number
    next_ranking_value: number
    ranking_slug: string
    rankings: RankingConfig[]
    date_reset_ranking: { now: string; next: string }
    total_order?: number
    voucher: {
      code?: string
      description: string
      label: string
      buttonText: string
    }
  }

type BodyParams = {
  height: number
  weight: number
}

type ExpiredCoolcash = {
  expired_minutes: number
  point_not_used: number
}

export type TUserProfile = {
  _id: string
  fullname: string
  email: string
  phone: string
  id: string
  gender: EGender
  birthday: number
  shipping_address: Omit<
    Address,
    | '_id'
    | 'default'
    | 'phone'
    | 'fullname'
    | 'user_id'
    | 'updated_at'
    | 'created_at'
  >
  updated_at: string
  created_at: string
  activation_code: string | null
  login_by_phone: boolean
  club_level: number
  has_account: boolean
  last_login: string
  event_register_insider: boolean
  address: string
  tags: string[]
  birth_year: number
  birthday_string: string
  height: number
  weight: number
  flag_processing: number
  discount_year: number
  bday_card: string
  used_birthday_success: number
  used_birthday_at: number
  children: unknown[]
  discount_code_birthday: string
  is_kol: boolean
  kol_id: string
  ranking: UserRanking
  lookback_discount_code: string
  lookback_discount_year: number
  activated: boolean
  addresses: Address[]
  body_params: BodyParams
  bust?: number | null
  under_bust?: number | null
  waist?: number | null
  hip?: number | null
  expired_coolcash_new_user: ExpiredCoolcash
  is_up_level_ranking: number
  discount_code: string
  token?: string
  device_token?: string
  user_id?: string
  is_login?: boolean
  new_offer_user?: boolean
}

export type TSendOtpParams = {
  type:
    | 'forgot_password'
    | 'login'
    | 'register'
    | 'update_phone'
    | 'confirm-info'
  phone?: string
}

export type TVerifyOtpParams = {
  type:
    | 'forgot_password'
    | 'login'
    | 'register'
    | 'update_phone'
    | 'confirm-info'
  phone: string
  otp: string
}

export type TVerifyOtpAuthParams = {
  type:
    | 'forgot_password'
    | 'login'
    | 'register'
    | 'update_phone'
    | 'confirm-info'
  phone?: string
  otp: string
  user_id: string
  fullname?: string
  email?: string
}

export type TVerifyOtpResponse = {
  status: EApiStatus
  message: string
}

export type TSendOtpResponse = {
  status: EApiStatus
  delay: number
  message: string
  error?: string
}

export type TForgotVerifyOtpParams = {
  phone: string
  otp: string
}

type UserVerifyOtp = {
  _id: string
  fullname: string
  email: string
  phone: string
  updated_at: string
  created_at: string
  activated: boolean
  activation_code: string
  id: string
  login_by_phone: boolean
  register_date: string
  birthday: string | null
  forgot_code: string
  ranking: string | null
}

export type TForgotVerifyOtpResponse = {
  status: EApiStatus
  user: UserVerifyOtp
  error?: string
  message?: string
}

export type TResetPasswordBody = {
  password: string
  forgot_code: string
}

export type TResetPasswordResponse = {
  status: EApiStatus
}

export type TForgotPasswordByEmailResponse = {
  status: EApiStatus
  message: string
  data: unknown
  error?: string
}

export type TRegisterResponse = {
  data: { user_id: string }
  message: string
  state: boolean
  status: number
}

export type TVerifyOtpAuthResponse = {
  data: { user: TUser }
  message: string
  state: boolean
  status: number
}

export enum ERankingLevel {
  NEW = '64ea032b9e826a5344bce9a9', // 'mới'
  SILVER = '64ea041d9e826a5344bce9b3', // 'bạc'
  GOLD = '64ea04359e826a5344bce9b4', // 'vàng'
  PLATINUM = '64ea04499e826a5344bce9b5', // 'bạch kim'
}

export const RANKING_LABEL: Record<ERankingLevel, string> = {
  [ERankingLevel.NEW]: 'new',
  [ERankingLevel.SILVER]: 'silver',
  [ERankingLevel.GOLD]: 'gold',
  [ERankingLevel.PLATINUM]: 'platinum',
}

export const RANKING_LABEL_VN: Record<ERankingLevel, string> = {
  [ERankingLevel.NEW]: 'Mới',
  [ERankingLevel.SILVER]: 'Bạc',
  [ERankingLevel.GOLD]: 'Vàng',
  [ERankingLevel.PLATINUM]: 'Bạch Kim',
}

export enum EGender {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'other',
}

export type TConfirmInfoUserBody = {
  fullname: string
  email: string
  phone: string
  user_id: string
}

export type TConfirmInfoUserResponse = {
  email: string
  fullname: string
  isset_phone: boolean
  user_id: string
}

export type TForgotPasswordBody = {
  type: 'phone' | 'email'
  value: string
}
